  <template >
  <div>
  <div>
  <div class="formPosition">
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

    <v-data-table    :headers="headers"  :items="estudantes" :search="searchInDb"  sort-by="data_"   class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">

       <!--  <v-btn to="/painelclasses" > <v-icon large color="green darken-2">arrow_back</v-icon> </v-btn > -->

                 <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Habilitar estudante à usuário
            </v-toolbar-title>

          <v-divider class="mx-8" inset vertical></v-divider>

          <!--  search  -->
<div   v-if="$store.state.hasMessage && cor=='red'" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
            v-model="searchInDb"
            append-icon="search"
            label="Pesquisa por nome , Bilhete de identidade ou Número de matricula"

            single-line
            hide-details
          ></v-text-field>
          <!-- end  search  -->

        <!-- =============                      ==================================== -->
                <v-row justify="center">

                      <v-dialog
                        v-model="dialog_show"
                        max-width="490"
                       >
                        <v-card>
                          <v-card-title class="headline">Habilitar Estudante à usuário</v-card-title>

                          <v-card-text>
                            <p  > Deseja Habilitar este estudante à usuário? Fazendo isso , o estudante poderá acessar ao sistema fornecendo as suas credenciais.</p>
                          </v-card-text>

                          <v-card-actions>
                            <v-row>
                   <v-col md="10"></v-col>
                      <v-col md="2" v-if="progresso">
                        <v-progress-circular
                        :size="50"
                        color="green"
                        indeterminate
                      ></v-progress-circular>
                      </v-col>

                </v-row>
                            <v-spacer></v-spacer>

                            <v-btn
                              color="red darken-1"
                              text
                              @click="dialog_show = false"
                            >
                              Cancelar
                            </v-btn>

                            <v-btn
                              color="green darken-1"
                              text
                              @click="AddUser()"
                            >
                             Concordar
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-row>
<!-- =========================================== -->
          <v-dialog v-model="dialog" max-width="800px">

            <v-card>

              <template >

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col  cols="12" md="4">

<v-btn text    @click="close"><v-icon large color="primary" >clear</v-icon></v-btn>

    </v-col>

     <v-col cols="12" md="7">  <!--  form titlte section   {{ formTitle }}-->
   Cadastrar   <span v-if="idclasse===1"> 10ª classe</span>
          <span v-if="idclasse===2"> 11ª classe</span><span v-if="idclasse===3"> 12ª classe</span>
          <span v-if="idclasse===4"> 13ª classe</span>
     </v-col>

      <v-col  cols="12" md="1">
     <v-btn   :disabled="!valid"           color="primary" text  @click="save"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>

  </v-row>

                  </v-toolbar>

              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>
                    <v-col  cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nome"
                        label="Nome"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                      required
                        :rules="ruleBI"
                        v-model="editedItem.bi"
                        :label="descricao"
                        v-mask="mascara"
                      ></v-text-field>

                    </v-col>
                    <v-col cols="12" md="2">
                      <v-switch v-model="dense" @change="outroDoc()"></v-switch>
                    </v-col>

 <v-col cols="12" md="3">

   <template>

  <v-menu
    ref="menubi"
    v-model="menubi"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.dataemissaobi"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de emissâo do BI"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      max="2019-12-31"
      min="1950-01-01"
      v-model="datebi"
      @change="saveDatebi"
    ></v-date-picker>
  </v-menu>
</template>
</v-col>

 <v-col cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-if="false"
                        v-model="editedItem.pkPessoa"
                        label="chave primaria auto increemente"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>

                    <v-col cols="12" md="4">

                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nomedopai"

                        label="Filho de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nomedamae"

                        label=" e de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                   <template>

  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.datanascimento"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de nascimento"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
  </template>
    <v-date-picker
      ref="picker"

      v-model="date"
     max="2006-12-31"
      min="1950-01-01"
      @change="saveDate"
    ></v-date-picker>
  </v-menu>
</template>

                    </v-col>

                  </v-row>

                   <v-row>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="proviSelectedForComb"
                        :items="provincias"
                        item-value="idProvicia"
                        item-text="descricao"
                          @change="loadMunicipioComb"
                          @click="loadMunicipioComb"

                        chips
                        label="Natural de:"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="municSelectedForComb"
                        :items="municipiosFiltered"
                        item-value="idMunicipio"
                        item-text="descricao"
                        chips
                        label="Municipio"
                      ></v-combobox>
                    </v-col>
                     <v-col cols="12" md="4">
                      <v-combobox
                        v-model="editedItem.sexo"
                        :rules="ruleRequired"
                        item-value="idSexo"
                        item-text="descricao"
                        :items="dropdowSexo"
                        chips
                        label="Sexo"
                      ></v-combobox>
                    </v-col>

                  </v-row>
                   <v-row>

   <v-col cols="12" md="4">
                      <v-combobox
                              v-if="true"
                                v-model="editedItem.curso"
                                :rules="ruleRequired"
                                item-value="idCurso"
                                item-text="descricao"
                                  @change="loadTurmaComb"
                                  @click="loadTurmaComb"

                                :items="cursos"
                                chips
                                label="Curso"
                      ></v-combobox>

                    </v-col>

<v-col cols="12" md="4">

                      <v-combobox  id="turma"
                      v-if="true"
                        v-model="editedItem.turma"
                        :rules="ruleRequired"
                        :value="undefined"
                        item-value="idTurma"
                        item-text="turmadescricao"
                        :items="turmasFiltered"
                        chips
                        label="Turma"
                      ></v-combobox>
                    </v-col>
<v-col cols="12" md="4">
                      <v-text-field
                      v-model="editedItem.telefone"

                       label="Telefone">
                       </v-text-field>
                  </v-col>

 </v-row>

                </v-container>
              </v-card-text>

</v-form>

            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn color="primary" fab small><v-icon class="mr-2" @click="ShowDialog(item)">person_add</v-icon></v-btn>
       </template>
      <template v-slot:no-data>
     <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->

     Clica em + para adicionar novo estudante
      </template>
    </v-data-table>

  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    datebi: null,
    progresso: false,
    date: null,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: true,
    turmasAll: [],
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],

    searchInDb: '',
    estudantes: [],
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Bilhete de Identidade / Outro documento', value: 'bi' },
      { text: 'Matricula', value: 'idMatricula' },
      { text: 'Curso', value: 'curso' },
      { text: 'Turma', value: 'turma' },
      { text: 'Resultado', value: 'resultado' },
      { text: 'Data de Cadastro/Moficação', value: 'data_' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    msg: '',
    dialog_show: false,
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      bi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      bi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select

    // this.CarregActividades()
    this.initialize()
    this.initializeMunicipiosAll()
    this.initializeProvincias()
    this.initializeCursos()
    this.initializeturmasAll()
  },

  methods: {
    async initialize (searchInDb) {
      try {
        //   let  payload =""
        if (!searchInDb) {
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"all"}'
        } else {
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"' + searchInDb + '"}'
        }

        this.isLoading = true
        this.estudantes = await axios
          .get('/estudanteFindAll-geral/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.descricao = 'Nº do Bi'
      } else {
        this.descricao = 'Outro Doc.'
      }
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },
    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },
    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async  AddUser () {
      this.progresso = true

      let params =
      {
        pkUsuario: 0,
        email: this.editedItem.nome,
        role: 'ROLE_EST',
        password: '1234',
        enable: 0
      }

      try {
        let corMensagem = 'msgError'
        let msg = await axios
          .post('/UsuarioInsertOrUpdate', params)
          .then(res => res.data)

        if (msg.length) {
          this.text = 'Ocorreu um erro ao tentar efectuar a operação.'
          corMensagem = 'msgError'
        } else {
          this.text = 'Operação efectuada com sucesso.'
          corMensagem = 'msgSucess'
          this.dialog_show = false
        }
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: corMensagem,
          timeout: 4000
        })
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
      } finally {
        this.progresso = false
      }
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    search (item) {
      this.$store.state.objaluno = item
      this.$router.push('estudante-historico')
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll () {
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    ShowDialog (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog_show = true
    },
    editItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      this.dialog = true
    },

    deleteItem (item) {
      const index = this.estudantes.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.delete(item.pkInscricao_na_turma)
      // this.estudantes.splice(index, 1)*/
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(date).toISOString().substr(0, 10)
    },
    async save () {
      if (this.$refs.form.validate()) {
        const ls = require('local-storage')
        var params = {
          pkPessoa: this.editedItem.pkPessoa,
          idPEssoa: this.editedItem.bi,
          idMunicipio: this.municSelectedForComb.idMunicipio,
          idPerfil: 1,
          nome: this.editedItem.nome,
          morada: this.editedItem.morada,
          telefone: this.editedItem.telefone,
          autor: ls.get('idPessoa'),
          datanascimento: this.editedItem.datanascimento,
          data_: this.editedItem.data_,
          status_2: this.editedItem.status_2,
          email: this.editedItem.email,
          sexo: 'M',
          nomedopai: this.editedItem.nomedopai,
          nomedamae: this.editedItem.nomedamae,
          dataemissaobi: this.editedItem.dataemissaobi,
          bi: this.editedItem.bi,
          ResidenteEm: 1,
          instituicao: ls.get('i_id'),
          instituicaodescricao: this.editedItem.instituicaodescricao,
          curso: this.editedItem.curso,
          turma: this.editedItem.turma,
          anolectivo: ls.get('anolectivo'),
          idanolectivo: ls.get('idanolectivo'),
          idanoacademico: this.idclasse
        }
        try {
          let msg = await axios
            .post('/estudanteInsertOrUpdate', params)
            .then(res => res.data)
          // this.text = msg[1].insertId
          this.text = msg
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 2000 })
            }
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          } catch (error) {}

          if (this.editedIndex > -1) {
          //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
          } else {
            this.estudantes.unshift(this.editedItem)
          }
          //  this.close();

          this.initialize()
        } catch (error) {
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } finally {

        }
        if (this.$store.msg === 'Número de Bi ja existente');
        else {
          this.editedItem.nome = ''
          this.editedItem.nomedopai = ''
          this.editedItem.nomedamae = ''
          this.editedItem.datanascimento = ''
          this.editedItem.dataemissaobi = ''
          this.editedItem.bi = ''
          this.editedItem.sexo = ''
          this.editedItem.telefone = ''
          this.editedItem.municipio = ''
          this.editedItem.provincia = ''
          this.$refs.form.resetValidation()
          if (this.editedItem.pkPessoa) {
            this.editedItem.pkPessoa = null
            setTimeout(() => {
              this.close()
            }, 1000)
          }
        }
      }
    },

    async delete (idv) {
      try {
        var msg = await axios
          .get('/estudanteDeleteById/' + idv)
          .then(res => res.data)
        this.text = 'Deleted ' + msg.message

        this.initialize()

        this.close()
      } catch (error) {
        this.text = error.message
      } finally {

      }
    }
  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
